import { Modal } from "react-bootstrap";
import { useTheme } from "../../../hooks/ThemeProvider";

export default function ActionFailModal({
  show,
  handleClose,
  title = "Failed",
  heading = "Transaction Failed",
  message = "Your transaction could not be completed. Please try again or check your wallet for details.",
  txHash,
  viewTx,
}) {
  // Shorten transaction hash for display
  const shortenHash = (hash) =>
    hash ? `${hash.slice(0, 10)}...${hash.slice(-4)}` : "";
  const { theme } = useTheme();
  return (
    <Modal className="stakingmodal" show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <p>{title}</p>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="succes_modal">
          <div className="top_success">
            <img src="\assets\cross.svg" alt="failed" />
            <h3>{heading}</h3>
            <p>{message}</p>
          </div>

          {txHash && (
            <div className="hash_div">
              <div>
                <p>Transaction Hash</p>
                <span>{shortenHash(txHash)}</span>
              </div>
              {viewTx && (
                <a href={viewTx} target="_blank" rel="noopener noreferrer">
                  <button>
                   {
        theme === 'dark' ?   <img src="\assets\whitetab.svg" alt="view" />
          : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
  <path d="M12.25 8.08333V11.5833C12.25 11.8928 12.1271 12.1895 11.9083 12.4083C11.6895 12.6271 11.3928 12.75 11.0833 12.75H2.91667C2.60725 12.75 2.3105 12.6271 2.09171 12.4083C1.87292 12.1895 1.75 11.8928 1.75 11.5833V3.41667C1.75 3.10725 1.87292 2.8105 2.09171 2.59171C2.3105 2.37292 2.60725 2.25 2.91667 2.25H6.41667" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12.25 2.25L7 7.5" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.75 2.25H12.25V5.75" stroke="#000F2F" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
      }
                    View
                  </button>
                </a>
              )}
            </div>
          )}

          <div className="buton_modal_div">
            <button onClick={handleClose}>Close</button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
